import { Component, OnInit, Input } from '@angular/core';

import { ReportItem } from '@classes/report/report-item';
import { ReportTypeCode } from '@enums/report-type-code.enum';
import { ChartType } from '@enums/chart-type.enum';

@Component({
    selector: 'app-report-variation-select',
    templateUrl: './report-variation-select.component.html',
    styleUrls: ['./report-variation-select.component.scss']
})
export class ReportVariationSelectComponent implements OnInit {
    @Input() reportItem: ReportItem;
    chartType = ChartType;
    constructor() { }

    ngOnInit() {
    }

}
